rjm.ui.ChartBuilderChartNameView = rjm.ui.ChartBuilderBlockableView.extend(
  events:
    "change #cbChartNameInput": "changeChartName"

  initialize: (options) ->
    if not options or not options.chartModel or not options.viewState
      throw "InvalidConstructorArgs - ChartBuilderChartNameView"

    _.bindAll this, "changeChartName", "generateTemplateData", "checkErrors", "render"
    #set incoming options
    @model = options.chartModel
    @viewState = options.viewState

    @viewState.bind "change:isSaving change:chartValidationErrors", @checkErrors
    @model.bind "change:name", @render

    return

  changeChartName: (e) ->
    e.preventDefault()
    newName = $(e.target).val()
    unless newName.match(/^\s*$/)
      @model.set name: newName
    else
      @render()
    return

  generateTemplateData: ->
    name: @model.get("name")
    isCompositeInput:  @model.get('isCompositeInput')
    isSharedDashboard:  parent.isSharedDashboard() and @model.get('id')? # Show the share warning on edits only
    alert: (@model.get('isCompositeInput') or (parent.isSharedDashboard() and @model.get('id')?))

  checkErrors: ->
    if _(@viewState.get("chartValidationErrors").name).isString() and not @viewState.get('isSaving')
      $(@el).find('#cbChartNameInput').popover
        title: "Error"
        container: 'body'
        content: @viewState.get("chartValidationErrors").name
        trigger: 'manual'
        placement: 'bottom'
      $(@el).find('#cbChartNameInput').popover('show').click (e)->
        e.preventDefault()
        $(this).popover("hide")
    else
      $(@el).find('#cbChartNameInput').popover('destroy')

  render: ->
    $(@el).find('#cbChartNameInput').popover('destroy') #make sure to remove the popover before wiping the html. TODO: fix the flow when model event binder is installed
    $(@el).html ich.chartBuilderChartName(@generateTemplateData())
    @checkErrors()
    return @
)
